<template>
  <Loading v-if="loading" />
  <Scrollbar class="team-setting">
    <div class="header">
      <div class="left">
        <svg-icon name="arrow-next" @click="handleLeave()" />
        <h1>Edit Role</h1>
      </div>
      <div class="btn-row" v-if="canEdit">
        <el-button @click="reset();">Reset</el-button>
        <el-button type="primary" @click="save()" :disabled="sameData">Save</el-button>
      </div>
    </div>

    <section class="all-settings" :key="refresh" v-if="!loading">
      <!-- Role -->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Role</h3>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <RoleSet :list="roleList" :key="roleRefrash" />
        </el-col>
      </el-row>

      <!-- Creator Management Dashboard -->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Creator Management Dashboard</h3>
          <p>
            View and manage creator activations and information within the Anchor portal.
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <ManageCreatorSet :data="allData.creatorManagement" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Analytics Dashboard -->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Analytics Dashboard</h3>
          <p>
            View and analyze overall program and creator performance.
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <AnalyticsSet :data="allData.analytics" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Content Moderation 9671-new(now temp)-->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Content Moderation</h3>
          <p>
            View and manage content within the storefront.<br/>
            Users can flag and disable posts and collections if given access to this feature.
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <ContentModerationSet :data="allData.contentModeration" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Recruitment Dashboard -->
      <el-row :gutter="60">
        <!-- team -->
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Recruitment Dashboard</h3>
          <p>
            Publish, manage, and review applications
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <RecruitmentSet :data="allData.recruitment" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Messages & Announcements -->
      <el-row :gutter="60">
        <!-- team -->
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Messages & Announcements</h3>
          <p>
            Communicate with creators through one-on-one messages or group-wide announcements.
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <MessageSet :data="allData.messagesAndAnnouncements" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Reports -->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Reports</h3>
          <p>
            Download creator, product, and collection performance data as .csv files.
          </p>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <ReportSet :data="allData.reports" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Settings - Workspace-->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Settings - Workspace</h3>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <SettingWorkspaceSet :data="allData.settingWorkspace" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Settings - Integrations-->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Settings - Integrations</h3>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <SettingIntegrationSet :data="allData.settingIntegrations" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Settings - Customization -->
      <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Settings - Customization</h3>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <SettingCustomSet :data="allData.settingCustomization" :isOwner="isOwner" :canEdit="canEdit" />
        </el-col>
      </el-row>

      <!-- Billing -->
      <!-- <el-row :gutter="60">
        <el-col :xs="col.xs" :sm="col.left_sm">
          <h3>Billing</h3>
        </el-col>

        <el-col :xs="col.xs" :sm="col.right_sm">
          <BillingSet />
        </el-col>
      </el-row> -->

    </section>
  </Scrollbar>

  <el-dialog title="Save changes?" width="400" v-model="saveDialog" @close="saveDialog = false"
    class="handle-save-dialog" :show-close="false">
    <p>Any unsaved changes will be permanently removed.</p>

    <div class="btn-row">
      <el-button @click="saveDialog = false; goBackToTeam();" type="text">Discard</el-button>
      <el-button type="primary" @click="save('leave');">Save & exit</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue';
import { useRoute, useRouter } from "vue-router";
import { ElRow, ElCol, ElButton, ElDialog } from 'element-plus';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import RoleSet from '@/components/settings/Team/RoleSet.vue';
import ManageCreatorSet from '@/components/settings/Team/ManageCreatorSet.vue';
import AnalyticsSet from '@/components/settings/Team/AnalyticsSet.vue';
import RecruitmentSet from '@/components/settings/Team/RecruitmentSet.vue';
import MessageSet from '@/components/settings/Team/MessageSet.vue';
import ReportSet from '@/components/settings/Team/ReportSet.vue';
import SettingWorkspaceSet from '@/components/settings/Team/SettingWorkspaceSet.vue';
import SettingIntegrationSet from '@/components/settings/Team/SettingIntegrationSet.vue';
import SettingCustomSet from '@/components/settings/Team/SettingCustomSet.vue';
import BillingSet from '@/components/settings/Team/BillingSet.vue';
import Loading from '@/components/ui/Loading.vue';
import Store from '@/store/index.js';
import ContentModerationSet from '@/components/settings/Team/ContentModerationSet.vue';

const col = ref({
  xs: 24,
  left_sm: 10,
  right_sm: 14,
});
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const notify = app.appContext.config.globalProperties.$notify;
const routerGo = useRouter();
const route = useRoute();
const nowRole = ref(route.params.subtype);
const roleList = ref([]);
const roleRefrash = ref(0);
const loading = ref(true);
const orgData = ref(null);
const allData = ref(null);
const roleName = ref('owner');
const saveDialog = ref(false);
//++++++++++++++++++++++++++++++++++++++++++++++++
const sameData = computed(() => {
  return JSON.stringify(allData.value) === JSON.stringify(orgData.value);
});

const isOwner = computed(() => {
  return allData.value?.role_type === 100 || allData.value?.role_type === 200;
});

const meIsOwner = computed(() => {
  let val = Store.state.user_data.permission_list;
  return val?.role_type === 100 || val?.role_type === 200;
});

const isAdmin = computed(() => {
  let val = Store.state.user_data.permission_list;
  return val?.role_type === 80;
});

const canEdit = computed(() => {
  return allData.value?.role_type !== 100 && allData.value?.role_type !== 200 && !(isAdmin.value && allData.value?.role_type === 80)
});
//++++++++++++++++++++++++++++++++++++++++++++++++
const getPermissionRole = () => {
  ajax.get('/settings/get-permission-role-list').then(res => {
    roleList.value = res.data.data;
    if (!meIsOwner.value) {
      roleList.value = roleList.value.filter(item => {
        return item.role_type !== 100 && item.role_type !== 200;
      });
    }
    roleRefrash.value += 1;
  });
};

const pickSelectPermissionRole = async () => {
  await ajax.get(`/settings/get-permission-list?role_id=${route.params.subtype}`).then(res => {
    console.log('pick', res.data.data);
    let data = res.data.data;
    orgData.value = JSON.parse(JSON.stringify(data));
    allData.value = JSON.parse(JSON.stringify(data));
    //->isParent=0=>only two permissionOption
  }).catch(err => {
    goBackToTeam();
  })
};

const reset = async () => {
  //allData.value = JSON.parse(JSON.stringify(orgData.value));
  loading.value = true;
  const data = {
    role_id: route.params.subtype
  };
  await ajax.post(`/settings/reset-role-permission`, data).then(res => {
    window.location.reload();
  }).catch(err => {
    notify({
      text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
      </svg>
      Permissions reset failed.`,
      group: 'white',
      type: 'warn',
    });
    loading.value = false;
  })
};

//check if the permission is changed
const findPermissionDiff = (newObj, oldObj) => {
  const result = {}

  const recursiveCheck = (newData, oldData) => {
    for (const key in newData) {
      if (typeof newData[key] === 'object' && newData[key] !== null) {
        // 如果是最內層，有 permission 欄位
        if ('permission' in newData[key] && 'permission' in (oldData?.[key] || {})) {
          if (newData[key].permission !== oldData[key]?.permission) {
            result[key] = newData[key].permission
          }
        } else {
          // 繼續深入檢查
          recursiveCheck(newData[key], oldData?.[key])
        }
      }
    }
  }

  recursiveCheck(newObj, oldObj)
  return result
};

const save = (val) => {
  let org = findPermissionDiff(allData.value, orgData.value);
  org.role_id = route.params.subtype;
  let formData = new FormData();
  Object.entries(org).forEach(([key, value]) => {
    formData.append(key, value);
  });
  loading.value = true;
  ajax.post(`/settings/update-role-permission`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(res => {
    notify({
      text: `<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z" />
      </svg> Permissions updated.`,
      group: 'white',
      type: 'success',
    });
    loading.value = false;
    orgData.value = JSON.parse(JSON.stringify(allData.value));
    if (val) {
      goBackToTeam();
    }
  }).catch(err => {
    notify({
      text: `<svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0.439453C4.48 0.439453 0 4.91945 0 10.4395C0 15.9595 4.48 20.4395 10 20.4395C15.52 20.4395 20 15.9595 20 10.4395C20 4.91945 15.52 0.439453 10 0.439453ZM11 15.4395H9V13.4395H11V15.4395ZM11 11.4395H9V5.43945H11V11.4395Z"/>
      </svg>
      Permissions updated failed.`,
      group: 'white',
      type: 'warn',
    });
    loading.value = false;
  })
};

const handleLeave = () => {
  if (JSON.stringify(allData.value) === JSON.stringify(orgData.value)) {
    goBackToTeam();
  } else {
    saveDialog.value = true;
  }
};

const goBackToTeam = () => {
  routerGo.push({
    name: 'settings',
    params: {
      type: 'team'
    }
  });
};

//++++++++++++++++++++++++++++++++++++++++++++++++
onMounted(async () => {
  // Call the function to fetch data when the component is mounted
  let permission = Store.state.user_data.permission_list;
  if (permission?.settingWorkspace.editRolePermissions.permission) {
    loading.value = true;
    await getPermissionRole();
    await pickSelectPermissionRole();
    loading.value = false;
  } else {
    goBackToTeam();
  }
});
</script>

<style lang="scss">
.team-setting {
  position: relative;
  height: 100%;

  .header {
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    background-color: #fff;

    .left {
      display: flex;
      align-items: center;
      gap: 16px;

      svg {
        width: 16px;
        height: 16px;
        cursor: pointer;
        rotate: -180deg;
      }

      h1 {
        font: var(--medium-24);
        color: var(--Black-100);
        flex: 1;
      }
    }
  }

  .all-settings {
    padding: 24px 0;
    overflow-x: hidden;

    .ui-alert.yellow {
      width: 100%;
      margin-bottom: 16px;
    }

    .yellow-2 {
      margin-top: 24px;
      margin-bottom: 0px !important;
    }

    .yellow3 {
      margin-top: 24px;
    }

    .handle-max-select {
      max-width: 200px;
    }

    .el-row {
      margin-top: 16px;

      &:first-child {
        margin-top: 0;
      }

      .el-col {
        background-color: var(--Black-00);

        &:first-child {
          padding: 0 16px 16px;

          h3 {
            font: var(--medium-20);
            color: var(--Text-primary);
            border-top: 1px solid var(--Black-40);
            padding-top: 16px;
            margin-bottom: 8px;
          }

          p {
            color: var(--Text-secondary);
            font-size: 14px;
          }

        }

        //right
        &:last-child {
          .edit-btn {
            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }

      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        h3 {
          font: var(--medium-16);
        }

        span {
          font-size: 16px;
        }

        &.section-header-spec {
          display: block;

          h3 {
            margin-bottom: 8px;
          }
        }

        &.section-header-2 {
          margin-top: 16px;
        }
      }

      .settings-container {
        background-color: var(--Black-03);
        padding: 16px;
        border-radius: 4px;

        .ui-switch.disabled span::before {
          border: solid 1px #eee;
        }

        .el-select {
          max-width: 200px;
          min-width: 200px;

          &.spec-select {
            max-width: unset;
          }

          .is-disabled .el-select__selected-item span {
            color: var(--black-50);
          }
        }

        .setting-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          font-size: 16px;
          color: var(--Text-primary);

        }

        .setting-description {
          color: var(--Text-secondary);
        }

        .indented {
          border-left: 3px solid var(--Black-40);
          padding-left: 16px;
        }

      }

    }

  }
}

.handle-save-dialog {
  .btn-row {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
}
</style>